import { render, staticRenderFns } from "./IadeArizaDetayFaturaSilButon.vue?vue&type=template&id=04175cf3&"
import script from "./IadeArizaDetayFaturaSilButon.vue?vue&type=script&lang=js&"
export * from "./IadeArizaDetayFaturaSilButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports